document.addEventListener("DOMContentLoaded", () => {

  /* ========================================
     BASIC ELEMENTS
  ======================================== */

  const hero =
    document.querySelector(".dd-hero");

  const loader =
    document.querySelector("[data-dd-loader]");

  const loaderProgress =
    document.querySelector("[data-dd-loader-progress]");

  const loaderNumber =
    document.querySelector("[data-dd-loader-number]");

  const heroVisual =
    document.querySelector(".dd-hero__visual");

  const discOne =
    document.querySelector(".dd-hero__disc--one");

  const discTwo =
    document.querySelector(".dd-hero__disc--two");

  const discThree =
    document.querySelector(".dd-hero__disc--three");

  const heroBox =
    document.querySelector(".dd-hero__box");

  const valueBand =
    document.querySelector(".dd-value-band");

  const howSection =
    document.querySelector(".dd-how-it-works");

  let loaderCompleteAnnounced = false;

  const announceLoaderComplete = () => {
    if (loaderCompleteAnnounced) return;
    loaderCompleteAnnounced = true;
    document.dispatchEvent(
      new CustomEvent("dd:loader-complete")
    );
  };


  /* ========================================
     HERO LOAD FUNCTION
  ======================================== */

  const startHero = () => {

    if (hero) {
      hero.classList.add(
        "dd-hero--loaded"
      );
    }

  };


  /* ========================================
     LOADER
  ======================================== */

  if (loader) {

    if (
      loader.classList.contains(
        "dd-loader--hide"
      )
    ) {

      startHero();
      window.requestAnimationFrame(
        announceLoaderComplete
      );

    } else {

    let progress = 0;

    const loadingInterval =
      setInterval(() => {

        progress += 2;

        if (progress > 100) {
          progress = 100;
        }

        if (loaderProgress) {
          loaderProgress.style.width =
            progress + "%";
        }

        if (loaderNumber) {
          loaderNumber.textContent =
            String(progress)
              .padStart(2, "0");
        }

        if (progress >= 100) {

          clearInterval(
            loadingInterval
          );

          setTimeout(() => {

            loader.classList.add(
              "dd-loader--opening"
            );

            setTimeout(() => {
              startHero();
            }, 250);

            setTimeout(() => {

              loader.classList.add(
                "dd-loader--hide"
              );

              announceLoaderComplete();

            }, 950);

          }, 100);

        }

      }, 16);

    }

  } else {

    startHero();
    window.requestAnimationFrame(
      announceLoaderComplete
    );

  }


  /* ========================================
     LEGACY HERO MOUSE PARALLAX
  ======================================== */

  if (
    heroVisual &&
    window.matchMedia(
      "(pointer: fine)"
    ).matches
  ) {

    heroVisual.addEventListener(
      "mousemove",
      (event) => {

        if (
          !hero ||
          !hero.classList.contains(
            "dd-hero--loaded"
          )
        ) {
          return;
        }

        const rect =
          heroVisual.getBoundingClientRect();

        const x =
          (
            event.clientX -
            rect.left
          ) /
          rect.width -
          0.5;

        const y =
          (
            event.clientY -
            rect.top
          ) /
          rect.height -
          0.5;

        if (discOne) {

          discOne.style.transform =
            `translate(${x * 24}px, ${y * 20}px)
             scale(1)
             rotate(-18deg)`;

        }

        if (discTwo) {

          discTwo.style.transform =
            `translate(${x * 42}px, ${y * 32}px)
             scale(1)
             rotate(14deg)`;

        }

        if (discThree) {

          discThree.style.transform =
            `translate(${x * 32}px, ${y * 28}px)
             scale(1)
             rotate(-8deg)`;

        }

        if (heroBox) {

          heroBox.style.transform =
            `translate(${x * -16}px, ${y * -12}px)
             scale(1)
             perspective(900px)
             rotateX(${8 + y * -3}deg)
             rotateY(${-12 + x * 4}deg)
             rotateZ(-4deg)`;

        }

      }
    );

    heroVisual.addEventListener(
      "mouseleave",
      () => {

        if (discOne) {
          discOne.style.transform =
            "translate(0px, 0px) scale(1) rotate(-18deg)";
        }

        if (discTwo) {
          discTwo.style.transform =
            "translate(0px, 0px) scale(1) rotate(14deg)";
        }

        if (discThree) {
          discThree.style.transform =
            "translate(0px, 0px) scale(1) rotate(-8deg)";
        }

        if (heroBox) {
          heroBox.style.transform =
            "translate(0px, 0px) scale(1) perspective(900px) rotateX(8deg) rotateY(-12deg) rotateZ(-4deg)";
        }

      }
    );

  }


  /* ========================================
     VALUE BAND SCROLL REVEAL
  ======================================== */

  if (valueBand) {

    const valueObserver =
      new IntersectionObserver(
        (entries, observer) => {

          entries.forEach(
            (entry) => {

              if (entry.isIntersecting) {

                valueBand.classList.add(
                  "dd-value-band--visible"
                );

                observer.unobserve(
                  entry.target
                );

              }

            }
          );

        },
        {
          threshold: 0.2,
          rootMargin:
            "0px 0px -80px 0px"
        }
      );

    valueObserver.observe(
      valueBand
    );

  }


  /* ========================================
     HOW IT WORKS SCROLL REVEAL
  ======================================== */

  if (howSection) {

    const howObserver =
      new IntersectionObserver(
        (entries, observer) => {

          entries.forEach(
            (entry) => {

              if (entry.isIntersecting) {

                howSection.classList.add(
                  "dd-how-it-works--visible"
                );

                observer.unobserve(
                  entry.target
                );

              }

            }
          );

        },
        {
          threshold: 0.15,
          rootMargin:
            "0px 0px -80px 0px"
        }
      );

    howObserver.observe(
      howSection
    );

  }


  /* ========================================
     PERSONALIZER
  ======================================== */

  const personalizer =
    document.querySelector(
      "[data-dd-personalizer]"
    );

  if (personalizer) {

    const flightBoxVariantId =
      Number(personalizer.dataset.ddVariantId);

    const flightBoxSellingPlanId =
      Number(personalizer.dataset.ddSellingPlanId);

    const accountProfileUrl =
      personalizer.dataset
        .ddAccountProfileUrl ||
      "/account";

    const profileCopy = {
      lock:
        personalizer.dataset.ddLockLabel ||
        "JOIN + LOCK MY FLIGHT",
      update:
        personalizer.dataset.ddUpdateLockLabel ||
        "UPDATE MY FLIGHT",
      locking:
        personalizer.dataset.ddLockingLabel ||
        "LOCKING IN YOUR FLIGHT…",
      locked:
        personalizer.dataset.ddLockedLabel ||
        "FLIGHT LOCKED ✓",
      signingIn:
        personalizer.dataset.ddSigningInLabel ||
        "TAKING YOU TO SECURE SIGN IN…",
      error:
        personalizer.dataset.ddSaveError ||
        "We could not save your Flight. Please try again.",
      savedStatus:
        personalizer.dataset.ddSavedStatus ||
        "Saved to your Shopify account.",
      loading:
        personalizer.dataset.ddLoadingProfile ||
        "Loading your saved Flight…"
    };

    const cartAddUrl =
      `${window.Shopify?.routes?.root || "/"}cart/add.js`;

    const cartChangeUrl =
      `${window.Shopify?.routes?.root || "/"}cart/change.js`;

    const isPrelaunch =
      personalizer.dataset.ddMode ===
      "prelaunch";

    const builderCountdown =
      personalizer.querySelector(
        "[data-dd-builder-countdown]"
      );

    if (builderCountdown) {

      const launchAt =
        Date.parse(
          personalizer.dataset.ddLaunchDate ||
          ""
        );

      const countdownStatus =
        builderCountdown.querySelector(
          "[data-dd-builder-countdown-status]"
        );

      const countdownValues = {
        days: builderCountdown.querySelector(
          '[data-dd-builder-countdown-value="days"]'
        ),
        hours: builderCountdown.querySelector(
          '[data-dd-builder-countdown-value="hours"]'
        ),
        minutes: builderCountdown.querySelector(
          '[data-dd-builder-countdown-value="minutes"]'
        ),
        seconds: builderCountdown.querySelector(
          '[data-dd-builder-countdown-value="seconds"]'
        )
      };

      if (Number.isFinite(launchAt)) {

        const updateBuilderCountdown = () => {

          const distance =
            Math.max(
              0,
              launchAt - Date.now()
            );

          const values = {
            days: Math.floor(
              distance / 86400000
            ),
            hours: Math.floor(
              distance / 3600000
            ) % 24,
            minutes: Math.floor(
              distance / 60000
            ) % 60,
            seconds: Math.floor(
              distance / 1000
            ) % 60
          };

          Object.entries(values).forEach(
            ([key, value]) => {
              if (countdownValues[key]) {
                countdownValues[key].textContent =
                  String(value).padStart(2, "0");
              }
            }
          );

          if (countdownStatus) {
            if (distance === 0) {
              countdownStatus.textContent =
                builderCountdown.dataset.ddCompleteLabel ||
                "";
            } else {
              countdownStatus.textContent = [
                `${values.days} ${builderCountdown.dataset.ddDaysLabel || ""}`,
                `${values.hours} ${builderCountdown.dataset.ddHoursLabel || ""}`,
                `${values.minutes} ${builderCountdown.dataset.ddMinutesLabel || ""}`,
                `${values.seconds} ${builderCountdown.dataset.ddSecondsLabel || ""}`
              ].join(", ");
            }
          }

        };

        updateBuilderCountdown();
        window.setInterval(
          updateBuilderCountdown,
          1000
        );

      }

    }

    const hasSellingPlan =
      Number.isFinite(flightBoxSellingPlanId) &&
      flightBoxSellingPlanId > 0;

    const commerceReady =
      isPrelaunch ||
      (
        Number.isFinite(flightBoxVariantId) &&
        flightBoxVariantId > 0 &&
        hasSellingPlan
      );

    const TOTAL_STEPS = 6;


    /* ========================================
       HELPERS
    ======================================== */

    const parseMultiValue = (
      value
    ) => {

      if (!value) {
        return [];
      }

      return value
        .split(",")
        .map(
          (item) =>
            item.trim()
        )
        .filter(Boolean);

    };


    const formatMultiValue = (
      value
    ) => {

      if (
        !Array.isArray(value)
      ) {
        return "";
      }

      return value.join(", ");

    };


    const toggleArrayValue = (
      array,
      value
    ) => {

      const index =
        array.indexOf(value);

      if (index >= 0) {

        array.splice(
          index,
          1
        );

      } else {

        array.push(
          value
        );

      }

    };


    /* ========================================
       URL / EDIT MODE
    ======================================== */

    const urlParams =
      new URLSearchParams(
        window.location.search
      );

    const isEditMode =
      urlParams.get(
        "edit_profile"
      ) === "true";

    const editLineKey =
      urlParams.get(
        "line"
      );

    const incomingFlight =
      urlParams.get(
        "flight"
      ) || "";

    const incomingSkill =
      urlParams.get(
        "skill"
      ) || "";

    const incomingWeight =
      urlParams.get(
        "weight"
      ) || "";

    const incomingColor =
      urlParams.get(
        "color"
      ) || "";

    const incomingBrands =
      urlParams.get(
        "brands"
      ) || "";

    const incomingDistance =
      urlParams.get(
        "distance"
      ) || "";

    /* ========================================
       ELEMENTS
    ======================================== */

    const steps =
      Array.from(
        personalizer.querySelectorAll(
          "[data-dd-step]"
        )
      );

    const navigation =
      personalizer.querySelector(
        ".dd-personalizer__navigation"
      );

    const nextButton =
      personalizer.querySelector(
        "[data-dd-personalizer-next]"
      );

    const backButton =
      personalizer.querySelector(
        "[data-dd-personalizer-back]"
      );

    const finishButton =
      personalizer.querySelector(
        "[data-dd-personalizer-finish]"
      );

    const cartStatus =
      personalizer.querySelector(
        "[data-dd-personalizer-cart-status]"
      );

    const prelaunchForm =
      personalizer.querySelector(
        ".dd-personalizer__prelaunch-form"
      );

    const prelaunchSuccess =
      personalizer.querySelector(
        "[data-dd-prelaunch-success]"
      );

    const profileStatus =
      personalizer.querySelector(
        "[data-dd-profile-status]"
      );

    const directSignup =
      personalizer.querySelector(
        "[data-dd-direct-signup]"
      );

    const directSignupResult =
      personalizer.querySelector(
        "[data-dd-direct-signup-result]"
      );

    if (
      directSignup &&
      directSignupResult
    ) {
      directSignup.open = true;
    }

    const summary =
      personalizer.querySelector(
        "[data-dd-summary]"
      );

    const reviewTransition =
      personalizer.querySelector(
        "[data-dd-review-transition]"
      );

    const progressNumber =
      personalizer.querySelector(
        "[data-dd-progress-number]"
      );

    const progressFill =
      personalizer.querySelector(
        "[data-dd-progress-fill]"
      );

    const showcase =
      personalizer.querySelector(
        "[data-dd-personalizer-showcase]"
      );

    const builder =
      personalizer.querySelector(
        "[data-dd-personalizer-builder]"
      );

    const startBuilderButton =
      personalizer.querySelector(
        "[data-dd-start-builder]"
      );

    const externalBuilderButtons =
      Array.from(
        document.querySelectorAll(
          '[data-dd-open-builder], a[href="#flight-profile"], a[href$="/#flight-profile"]'
        )
      );

    const productSurface =
      personalizer.querySelector(
        "[data-dd-builder-product-surface]"
      );

    const prefersReducedMotion =
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;


    /* SUMMARY VALUES */

    const summaryFlight =
      personalizer.querySelector(
        "[data-dd-summary-flight]"
      );

    const summarySkill =
      personalizer.querySelector(
        "[data-dd-summary-skill]"
      );

    const summaryWeight =
      personalizer.querySelector(
        "[data-dd-summary-weight]"
      );

    const summaryColor =
      personalizer.querySelector(
        "[data-dd-summary-color]"
      );

    const summaryBrands =
      personalizer.querySelector(
        "[data-dd-summary-brands]"
      );

    const summaryDistance =
      personalizer.querySelector(
        "[data-dd-summary-distance]"
      );

    /* HIDDEN INPUTS */

    const inputFlight =
      personalizer.querySelector(
        "[data-dd-input-flight]"
      );

    const inputSkill =
      personalizer.querySelector(
        "[data-dd-input-skill]"
      );

    const inputWeight =
      personalizer.querySelector(
        "[data-dd-input-weight]"
      );

    const inputColor =
      personalizer.querySelector(
        "[data-dd-input-color]"
      );

    const inputBrands =
      personalizer.querySelector(
        "[data-dd-input-brands]"
      );

    const inputDistance =
      personalizer.querySelector(
        "[data-dd-input-distance]"
      );

    /* ========================================
       STATE
    ======================================== */

    let currentStep = 1;

    let builderStarted =
      isEditMode ||
      !showcase;

    const answers = {

      flight:
        incomingFlight,

      skill:
        incomingSkill,

      weight:
        parseMultiValue(
          incomingWeight
        ),

      color:
        parseMultiValue(
          incomingColor
        ),

      brands:
        parseMultiValue(
          incomingBrands
        ),

      distance:
        incomingDistance

    };

    const prelaunchProfileStorageKey =
      "dd:prelaunch:flight-profile:v1";

    const prelaunchSubmitStorageKey =
      "dd:prelaunch:builder-submit:v1";


    const stepKeys = {

      1: "flight",

      2: "skill",

      3: "weight",

      4: "color",

      5: "brands",

      6: "distance"

    };


    const multiSelectTypes =
      new Set([
        "weight",
        "color",
        "brands"
      ]);

    const restorePrelaunchProfile = () => {

      if (!isPrelaunch) {
        return;
      }

      try {

        const storedProfile =
          JSON.parse(
            window.localStorage.getItem(
              prelaunchProfileStorageKey
            ) || "null"
          );

        if (
          !storedProfile ||
          typeof storedProfile !==
            "object"
        ) {
          return;
        }

        answers.flight =
          typeof storedProfile.flight ===
            "string"
            ? storedProfile.flight
            : "";

        answers.skill =
          typeof storedProfile.skill ===
            "string"
            ? storedProfile.skill
            : "";

        answers.weight =
          Array.isArray(
            storedProfile.weight
          )
            ? storedProfile.weight
            : [];

        answers.color =
          Array.isArray(
            storedProfile.color
          )
            ? storedProfile.color
            : [];

        answers.brands =
          Array.isArray(
            storedProfile.brands
          )
            ? storedProfile.brands
            : [];

        answers.distance =
          typeof storedProfile.distance ===
            "string"
            ? storedProfile.distance
            : "";

      } catch (_) {

        return;

      }

    };

    const profileIsComplete = () =>
      Boolean(
        answers.flight
      ) &&
      Boolean(
        answers.skill
      ) &&
      answers.weight.length > 0 &&
      answers.color.length > 0 &&
      answers.brands.length > 0 &&
      Boolean(
        answers.distance
      );

    const profileFromAnswers = () => ({
      flightConfiguration:
        answers.flight,
      skillLevel:
        answers.skill,
      weightPreference:
        [...answers.weight],
      colorPreference:
        [...answers.color],
      preferredBrands:
        [...answers.brands],
      throwDistance:
        answers.distance
    });

    const setFinishLabel = (
      label,
      showArrow = true
    ) => {

      if (!finishButton) {
        return;
      }

      finishButton.replaceChildren();
      const labelElement =
        document.createElement("span");
      labelElement.className =
        "dd-personalizer__finish-label";
      labelElement.textContent = label;
      finishButton.appendChild(
        labelElement
      );

      if (showArrow) {
        const arrowElement =
          document.createElement("span");
        arrowElement.className =
          "dd-personalizer__finish-arrow";
        arrowElement.setAttribute(
          "aria-hidden",
          "true"
        );
        arrowElement.textContent = "→";
        finishButton.appendChild(
          arrowElement
        );
      }

    };

    const setProfileStatus = (
      message,
      state = "success"
    ) => {

      if (!profileStatus) {
        return;
      }

      profileStatus.textContent =
        message || "";
      profileStatus.dataset.state = state;
      profileStatus.hidden = !message;

    };


    /* ========================================
       CHOICE CLASS HELPERS
    ======================================== */

    const addSelectedClass = (
      choice
    ) => {

      choice.setAttribute(
        "aria-pressed",
        "true"
      );

      if (
        choice.classList.contains(
          "dd-color-option"
        )
      ) {

        choice.classList.add(
          "dd-color-option--selected"
        );

      } else {

        choice.classList.add(
          "dd-personalizer__choice--selected"
        );

      }

    };


    const removeSelectedClass = (
      choice
    ) => {

      choice.setAttribute(
        "aria-pressed",
        "false"
      );

      if (
        choice.classList.contains(
          "dd-color-option"
        )
      ) {

        choice.classList.remove(
          "dd-color-option--selected"
        );

      } else {

        choice.classList.remove(
          "dd-personalizer__choice--selected"
        );

      }

    };


    /* ========================================
       PRESELECT EXISTING ANSWERS
    ======================================== */

    const preselectAnswers = () => {

      const allChoices =
        personalizer.querySelectorAll(
          "[data-dd-choice][data-dd-value]"
        );

      allChoices.forEach(
        (choice) => {

          choice.setAttribute(
            "aria-pressed",
            "false"
          );

          const type =
            choice.getAttribute(
              "data-dd-choice"
            );

          const value =
            choice.getAttribute(
              "data-dd-value"
            );

          if (
            !type ||
            !value
          ) {
            return;
          }


          if (
            multiSelectTypes.has(
              type
            )
          ) {

            if (
              Array.isArray(
                answers[type]
              ) &&
              answers[type].includes(
                value
              )
            ) {

              addSelectedClass(
                choice
              );

            }

          } else {

            if (
              answers[type] ===
              value
            ) {

              addSelectedClass(
                choice
              );

            }

          }

        }
      );

    };

    const applyProfile = (
      profile
    ) => {

      if (!profile) {
        return false;
      }

      answers.flight =
        profile.flightConfiguration || "";
      answers.skill =
        profile.skillLevel || "";
      answers.weight =
        Array.isArray(profile.weightPreference)
          ? [...profile.weightPreference]
          : [];
      answers.color =
        Array.isArray(profile.colorPreference)
          ? [...profile.colorPreference]
          : [];
      answers.brands =
        Array.isArray(profile.preferredBrands)
          ? [...profile.preferredBrands]
          : [];
      answers.distance =
        profile.throwDistance || "";

      personalizer
        .querySelectorAll(
          "[data-dd-choice][data-dd-value]"
        )
        .forEach(removeSelectedClass);

      preselectAnswers();
      updateNavigation();

      return profileIsComplete();

    };


    /* ========================================
       UPDATE PROGRESS
    ======================================== */

    const updateProgress = () => {

      if (progressNumber) {

        progressNumber.textContent =
          String(currentStep)
            .padStart(2, "0") +
          " / " +
          String(TOTAL_STEPS)
            .padStart(2, "0");

      }

      if (progressFill) {

        progressFill.style.width =
          `${
            (
              currentStep /
              TOTAL_STEPS
            ) *
            100
          }%`;

      }

    };


    /* ========================================
       CURRENT ANSWER CHECK
    ======================================== */

    const stepHasAnswer = () => {

      const key =
        stepKeys[
          currentStep
        ];

      const value =
        answers[key];

      if (
        Array.isArray(value)
      ) {

        return (
          value.length > 0
        );

      }

      return Boolean(value);

    };


    /* ========================================
       UPDATE NAVIGATION
    ======================================== */

    const updateNavigation = () => {

      if (backButton) {

        backButton.disabled =
          currentStep === 1;

      }

      if (nextButton) {

        nextButton.disabled =
          !stepHasAnswer();

        if (
          currentStep ===
          TOTAL_STEPS
        ) {

          nextButton.innerHTML =
            `REVIEW FLIGHT <span>→</span>`;

        } else {

          nextButton.innerHTML =
            `NEXT <span>→</span>`;

        }

      }

    };


    /* ========================================
       SHOW STEP
    ======================================== */

    const showStep = (
      stepNumber
    ) => {

      personalizer.classList.remove(
        "dd-personalizer--reviewing"
      );

      document.documentElement.classList.remove(
        "dd-flight-review-active"
      );

      if (reviewTransition) {
        reviewTransition.setAttribute(
          "aria-hidden",
          "true"
        );
      }

      currentStep =
        stepNumber;

      steps.forEach(
        (step) => {

          const stepValue =
            Number(
              step.getAttribute(
                "data-dd-step"
              )
            );

          step.classList.toggle(
            "dd-personalizer__step--active",
            stepValue ===
              currentStep
          );

          step.hidden =
            stepValue !==
            currentStep;

          step.setAttribute(
            "aria-hidden",
            String(
              stepValue !==
              currentStep
            )
          );

        }
      );

      if (summary) {

        summary.classList.remove(
          "dd-personalizer__summary--active"
        );

        summary.hidden = true;

        summary.setAttribute(
          "aria-hidden",
          "true"
        );

      }

      if (navigation) {

        navigation.style.display =
          "flex";

      }

      updateProgress();
      updateNavigation();

    };


    /* ========================================
       PRODUCT INTRO / BUILDER LAUNCH
    ======================================== */

    const showBuilder = (
      shouldScroll = true
    ) => {

      personalizer.classList.remove(
        "dd-personalizer--showcase",
        "dd-personalizer--launching"
      );

      personalizer.classList.add(
        "dd-personalizer--building"
      );

      if (showcase) {
        showcase.hidden = true;
      }

      if (builder) {
        builder.setAttribute(
          "aria-hidden",
          "false"
        );
      }

      if (shouldScroll) {
        requestAnimationFrame(
          () => {
            personalizer.scrollIntoView({
              behavior:
                prefersReducedMotion
                  ? "auto"
                  : "smooth",
              block: "start"
            });
          }
        );
      }

    };


    const launchBuilder = () => {

      if (builderStarted) {
        return;
      }

      builderStarted = true;

      personalizer.classList.add(
        "dd-personalizer--launching"
      );

      window.setTimeout(
        () => {
          showBuilder();
        },
        prefersReducedMotion
          ? 0
          : 820
      );

    };


    if (startBuilderButton) {
      startBuilderButton.addEventListener(
        "click",
        launchBuilder
      );
    }

    externalBuilderButtons.forEach(
      (button) => {
        button.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            launchBuilder();
          }
        );
      }
    );

    const openBuilderFromLink = () => {

      if (
        window.location.hash !==
        "#flight-profile"
      ) {
        return;
      }

      if (builderStarted) {
        showBuilder(false);
      } else {
        launchBuilder();
      }

    };

    window.addEventListener(
      "hashchange",
      openBuilderFromLink
    );


    if (
      productSurface &&
      !prefersReducedMotion &&
      window.matchMedia("(pointer: fine)").matches
    ) {

      let pointerFrame = null;
      let pointerEvent = null;

      const updateProductTilt = () => {

        pointerFrame = null;

        if (!pointerEvent) {
          return;
        }

        const bounds =
          productSurface.getBoundingClientRect();

        const x =
          (
            pointerEvent.clientX -
            bounds.left
          ) /
          bounds.width -
          0.5;

        const y =
          (
            pointerEvent.clientY -
            bounds.top
          ) /
          bounds.height -
          0.5;

        productSurface.style.setProperty(
          "--dd-product-tilt-x",
          `${(-y * 7).toFixed(2)}deg`
        );

        productSurface.style.setProperty(
          "--dd-product-tilt-y",
          `${(x * 9).toFixed(2)}deg`
        );

        productSurface.style.setProperty(
          "--dd-product-shift-x",
          `${(x * 10).toFixed(2)}px`
        );

        productSurface.style.setProperty(
          "--dd-product-shift-y",
          `${(y * 8).toFixed(2)}px`
        );

      };

      productSurface.addEventListener(
        "pointermove",
        (event) => {

          pointerEvent = event;

          if (!pointerFrame) {
            pointerFrame =
              requestAnimationFrame(
                updateProductTilt
              );
          }

        }
      );

      productSurface.addEventListener(
        "pointerleave",
        () => {

          pointerEvent = null;

          productSurface.style.removeProperty(
            "--dd-product-tilt-x"
          );

          productSurface.style.removeProperty(
            "--dd-product-tilt-y"
          );

          productSurface.style.removeProperty(
            "--dd-product-shift-x"
          );

          productSurface.style.removeProperty(
            "--dd-product-shift-y"
          );

        }
      );

    }


    /* ========================================
       SHOW SUMMARY
    ======================================== */

    const showSummary = () => {

      document.documentElement.classList.add(
        "dd-flight-review-active"
      );

      steps.forEach(
        (step) => {

          step.classList.remove(
            "dd-personalizer__step--active"
          );

          step.hidden = true;

          step.setAttribute(
            "aria-hidden",
            "true"
          );

        }
      );

      if (summary) {

        summary.classList.add(
          "dd-personalizer__summary--active"
        );

        summary.hidden = false;

        summary.setAttribute(
          "aria-hidden",
          "false"
        );

      }

      const weightString =
        formatMultiValue(
          answers.weight
        );

      const colorString =
        formatMultiValue(
          answers.color
        );

      const brandsString =
        formatMultiValue(
          answers.brands
        );


      if (summaryFlight) {
        summaryFlight.textContent =
          answers.flight;
      }

      if (summarySkill) {
        summarySkill.textContent =
          answers.skill;
      }

      if (summaryWeight) {
        summaryWeight.textContent =
          weightString;
      }

      if (summaryColor) {
        summaryColor.textContent =
          colorString;
      }

      if (summaryBrands) {
        summaryBrands.textContent =
          brandsString;
      }

      if (summaryDistance) {
        summaryDistance.textContent =
          answers.distance;
      }

      if (inputFlight) {
        inputFlight.value =
          answers.flight;
      }

      if (inputSkill) {
        inputSkill.value =
          answers.skill;
      }

      if (inputWeight) {
        inputWeight.value =
          weightString;
      }

      if (inputColor) {
        inputColor.value =
          colorString;
      }

      if (inputBrands) {
        inputBrands.value =
          brandsString;
      }

      if (inputDistance) {
        inputDistance.value =
          answers.distance;
      }

      if (progressNumber) {
        progressNumber.textContent =
          "COMPLETE";
      }

      if (progressFill) {
        progressFill.style.width =
          "100%";
      }

      if (navigation) {
        navigation.style.display =
          "none";
      }

      if (finishButton) {

        if (isPrelaunch) {

          finishButton.disabled =
            false;

          setFinishLabel(
            profileCopy.lock
          );

        } else if (!commerceReady) {

          finishButton.disabled =
            true;

          setFinishLabel(
            "CURRENTLY UNAVAILABLE",
            false
          );

        } else if (isEditMode) {

          setFinishLabel(
            "UPDATE MY FLIGHT"
          );

        } else {

          setFinishLabel(
            "BUY MY FLIGHT NOW"
          );

        }

      }

    };


    /* ========================================
       REVIEW REVEAL
    ======================================== */

    const centerSummaryInViewport = () => {

      window.requestAnimationFrame(
        () => {
          summary.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "nearest"
          });
        }
      );

    };

    const revealSummary = () => {

      if (
        !summary ||
        personalizer.classList.contains(
          "dd-personalizer--reviewing"
        )
      ) {
        return;
      }

      if (prefersReducedMotion) {
        showSummary();
        centerSummaryInViewport();

        return;
      }

      personalizer.classList.add(
        "dd-personalizer--reviewing"
      );

      if (reviewTransition) {
        reviewTransition.setAttribute(
          "aria-hidden",
          "false"
        );
      }

      if (nextButton) {
        nextButton.disabled = true;
      }

      window.setTimeout(
        () => {
          showSummary();
          centerSummaryInViewport();
        },
        560
      );

      window.setTimeout(
        () => {
          personalizer.classList.remove(
            "dd-personalizer--reviewing"
          );

          if (reviewTransition) {
            reviewTransition.setAttribute(
              "aria-hidden",
              "true"
            );
          }
        },
        1280
      );

    };


    /* ========================================
       SINGLE-SELECT CHOICES
    ======================================== */

    personalizer.addEventListener(
      "click",
      (event) => {
        if (
          event.target.closest(
            "[data-dd-choice][data-dd-value]"
          )
        ) {
          setProfileStatus("");
        }
      }
    );

    const singleChoices =
      personalizer.querySelectorAll(
        "[data-dd-choice][data-dd-value]:not([data-dd-multi-choice])"
      );

    singleChoices.forEach(
      (choice) => {

        choice.addEventListener(
          "click",
          () => {

            const type =
              choice.getAttribute(
                "data-dd-choice"
              );

            const value =
              choice.getAttribute(
                "data-dd-value"
              );

            if (
              !type ||
              !value
            ) {
              return;
            }

            personalizer
              .querySelectorAll(
                `[data-dd-choice="${type}"]`
              )
              .forEach(
                (item) => {

                  removeSelectedClass(
                    item
                  );

                }
              );

            addSelectedClass(
              choice
            );

            answers[type] =
              value;

            updateNavigation();

          }
        );

      }
    );


    /* ========================================
       MULTI-SELECT CHOICES
    ======================================== */

    const multiChoices =
      personalizer.querySelectorAll(
        "[data-dd-multi-choice]"
      );

    multiChoices.forEach(
      (choice) => {

        choice.addEventListener(
          "click",
          () => {

            const type =
              choice.getAttribute(
                "data-dd-choice"
              );

            const value =
              choice.getAttribute(
                "data-dd-value"
              );

            if (
              !type ||
              !value
            ) {
              return;
            }

            if (
              !Array.isArray(
                answers[type]
              )
            ) {

              answers[type] =
                [];

            }


            const isExclusive =
              choice.hasAttribute(
                "data-dd-exclusive-choice"
              );


            /* =====================================
               BRAND SURPRISE ME
            ====================================== */

            if (
              type === "brands"
            ) {

              const typeChoices =
                personalizer.querySelectorAll(
                  `[data-dd-choice="${type}"]`
                );

              if (isExclusive) {

                const alreadySelected =
                  answers[type].includes(
                    value
                  );

                typeChoices.forEach(
                  (item) => {

                    removeSelectedClass(
                      item
                    );

                  }
                );

                answers[type] =
                  alreadySelected
                    ? []
                    : [value];

                if (
                  !alreadySelected
                ) {

                  addSelectedClass(
                    choice
                  );

                }

                updateNavigation();

                return;

              }


              typeChoices.forEach(
                (item) => {

                  if (
                    item.hasAttribute(
                      "data-dd-exclusive-choice"
                    )
                  ) {

                    const exclusiveValue =
                      item.getAttribute(
                        "data-dd-value"
                      );

                    answers[type] =
                      answers[type].filter(
                        (answer) =>
                          answer !==
                          exclusiveValue
                      );

                    removeSelectedClass(
                      item
                    );

                  }

                }
              );

            }


            /* =====================================
               COLOR ANYTHING
            ====================================== */

            if (
              type === "color"
            ) {

              const typeChoices =
                personalizer.querySelectorAll(
                  `[data-dd-choice="${type}"]`
                );

              const isAnything =
                choice.hasAttribute(
                  "data-dd-color-anything"
                );

              if (isAnything) {

                const alreadySelected =
                  answers[type].includes(
                    value
                  );

                typeChoices.forEach(
                  (item) => {

                    removeSelectedClass(
                      item
                    );

                  }
                );

                answers[type] =
                  alreadySelected
                    ? []
                    : [value];

                if (
                  !alreadySelected
                ) {

                  addSelectedClass(
                    choice
                  );

                }

                updateNavigation();

                return;

              }


              typeChoices.forEach(
                (item) => {

                  if (
                    item.hasAttribute(
                      "data-dd-color-anything"
                    )
                  ) {

                    const anythingValue =
                      item.getAttribute(
                        "data-dd-value"
                      );

                    answers[type] =
                      answers[type].filter(
                        (answer) =>
                          answer !==
                          anythingValue
                      );

                    removeSelectedClass(
                      item
                    );

                  }

                }
              );

            }


            /* =====================================
               NORMAL MULTI-SELECT TOGGLE
            ====================================== */

            toggleArrayValue(
              answers[type],
              value
            );

            if (
              answers[type].includes(
                value
              )
            ) {

              addSelectedClass(
                choice
              );

            } else {

              removeSelectedClass(
                choice
              );

            }

            updateNavigation();

          }
        );

      }
    );


    /* ========================================
       NEXT
    ======================================== */

    if (nextButton) {

      nextButton.addEventListener(
        "click",
        () => {

          if (
            !stepHasAnswer()
          ) {
            return;
          }

          if (
            currentStep <
            TOTAL_STEPS
          ) {

            showStep(
              currentStep + 1
            );

          } else {

            revealSummary();

          }

        }
      );

    }


    /* ========================================
       BACK
    ======================================== */

    if (backButton) {

      backButton.addEventListener(
        "click",
        () => {

          if (
            currentStep > 1
          ) {

            showStep(
              currentStep - 1
            );

          }

        }
      );

    }


    /* ========================================
       EDIT FROM SUMMARY
    ======================================== */

    const editButtons =
      personalizer.querySelectorAll(
        "[data-dd-edit-step]"
      );

    editButtons.forEach(
      (button) => {

        button.addEventListener(
          "click",
          () => {

            const stepNumber =
              Number(
                button.getAttribute(
                  "data-dd-edit-step"
                )
              );

            if (!stepNumber) {
              return;
            }

            showStep(
              stepNumber
            );

            personalizer.scrollIntoView({
              behavior:
                "smooth",
              block:
                "start"
            });

          }
        );

      }
    );


    /* ========================================
       BUILD SHOPIFY PROPERTIES
    ======================================== */

    const getCartProperties = () => {

      const properties = {

        "Flight Configuration":
          answers.flight,

        "Skill Level":
          answers.skill,

        "Weight Preference":
          formatMultiValue(
            answers.weight
          ),

        "Color Preference":
          formatMultiValue(
            answers.color
          ),

        "Preferred Brands":
          formatMultiValue(
            answers.brands
          ),

        "Max Distance":
          answers.distance

      };

      try {

        const firstDropSelection =
          window.localStorage.getItem(
            "dd:first-drop:selection:v2"
          );

        const firstDropComplete =
          window.localStorage.getItem(
            "dd:first-drop:completed:v2"
          ) === "true";

        if (
          firstDropComplete &&
          firstDropSelection === "free_towel"
        ) {

          properties["First Drop Reward"] =
            "Free ThrowCo towel";

        }

        if (
          firstDropComplete &&
          firstDropSelection === "free_disc"
        ) {

          properties["First Drop Reward"] =
            "Free mystery disc";

        }

      } catch (_) {

        return properties;

      }

      return properties;

    };

    /* ========================================
       SHOPIFY CUSTOMER PROFILE
    ======================================== */

    const readPendingProfile = () => {
      try {
        const stored = JSON.parse(
          window.localStorage.getItem(
            prelaunchProfileStorageKey
          ) || "null"
        );
        if (!stored) {
          return null;
        }
        if (stored.flightConfiguration) {
          return stored;
        }
        return {
          flightConfiguration:
            stored.flight || "",
          skillLevel:
            stored.skill || "",
          weightPreference:
            Array.isArray(stored.weight)
              ? stored.weight
              : [],
          colorPreference:
            Array.isArray(stored.color)
              ? stored.color
              : [],
          preferredBrands:
            Array.isArray(stored.brands)
              ? stored.brands
              : [],
          throwDistance:
            stored.distance || ""
        };
      } catch (_) {
        return null;
      }
    };

    const savePendingProfile = () => {
      try {
        window.localStorage.setItem(
          prelaunchProfileStorageKey,
          JSON.stringify({
            flight: answers.flight,
            skill: answers.skill,
            weight: answers.weight,
            color: answers.color,
            brands: answers.brands,
            distance: answers.distance,
            savedAt: new Date().toISOString()
          })
        );
      } catch (_) {
        return;
      }
    };

    const buildAccountProfileUrl = (
      destination = ""
    ) => {
      const profile = profileFromAnswers();
      const accountUrl = new URL(
        accountProfileUrl,
        window.location.origin
      );

      [
        "flight",
        "skill",
        "weight",
        "color",
        "brand",
        "distance",
        "next"
      ].forEach((key) =>
        accountUrl.searchParams.delete(key)
      );

      accountUrl.searchParams.set(
        "flight",
        profile.flightConfiguration
      );
      accountUrl.searchParams.set(
        "skill",
        profile.skillLevel
      );
      accountUrl.searchParams.set(
        "distance",
        profile.throwDistance
      );

      profile.weightPreference.forEach(
        (value) =>
          accountUrl.searchParams.append(
            "weight",
            value
          )
      );
      profile.colorPreference.forEach(
        (value) =>
          accountUrl.searchParams.append(
            "color",
            value
          )
      );
      profile.preferredBrands.forEach(
        (value) =>
          accountUrl.searchParams.append(
            "brand",
            value
          )
      );

      if (destination) {
        accountUrl.searchParams.set(
          "next",
          destination
        );
      }

      return accountUrl.toString();
    };

    const redirectToAccountProfile = (
      destination = ""
    ) => {
      savePendingProfile();
      setFinishLabel(
        profileCopy.signingIn,
        false
      );
      window.location.href =
        buildAccountProfileUrl(destination);
    };


    /* ========================================
       ADD NEW FLIGHT BOX
    ======================================== */

    const addFlightBoxToCart =
      async () => {

        if (!commerceReady) {

          throw new Error(
            "Flight Box product or selling plan is not configured."
          );

        }

        const cartItem = {
          id:
            flightBoxVariantId,

          quantity:
            1,

          properties:
            getCartProperties()
        };

        if (hasSellingPlan) {

          cartItem.selling_plan =
            flightBoxSellingPlanId;

        }

        const response =
          await fetch(
            cartAddUrl,
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              body:
                JSON.stringify({
                  items: [cartItem]
                })
            }
          );

        const result =
          await response.json();

        if (!response.ok) {

          throw new Error(
            result.description ||
            result.message ||
            "Could not add Flight Box."
          );

        }

        return result;

      };


    /* ========================================
       UPDATE EXISTING FLIGHT BOX
    ======================================== */

    const updateFlightBoxProfile =
      async () => {

        if (!editLineKey) {

          throw new Error(
            "Missing cart line key."
          );

        }

        const changePayload = {
          id:
            editLineKey,

          quantity:
            1,

          properties:
            getCartProperties()
        };

        if (hasSellingPlan) {

          changePayload.selling_plan =
            flightBoxSellingPlanId;

        }

        const response =
          await fetch(
            cartChangeUrl,
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              body:
                JSON.stringify(changePayload)
            }
          );

        const result =
          await response.json();

        if (!response.ok) {

          throw new Error(
            result.description ||
            result.message ||
            "Could not update Flight."
          );

        }

        return result;

      };


    /* ========================================
       FINISH BUTTON
    ======================================== */

    if (
      finishButton &&
      !isPrelaunch
    ) {

      finishButton.addEventListener(
        "click",
        async () => {

          const isComplete =
            profileIsComplete();

          if (!isComplete) {
            return;
          }

          finishButton.disabled =
            true;

          if (cartStatus) {
            cartStatus.hidden = true;
            cartStatus.textContent = "";
          }

          try {

            if (isEditMode) {

              setFinishLabel(
                "UPDATING FLIGHT…",
                false
              );

              await updateFlightBoxProfile();

              setFinishLabel(
                "FLIGHT UPDATED ✓",
                false
              );

            } else {

              setFinishLabel(
                "PREPARING YOUR FLIGHT…",
                false
              );

              await addFlightBoxToCart();

              setFinishLabel(
                "FLIGHT ADDED ✓",
                false
              );

            }

            redirectToAccountProfile(
              "cart"
            );

          } catch (error) {

            console.error(
              "Flight Box cart error:",
              error
            );

            finishButton.disabled =
              false;

            setFinishLabel(
              "TRY AGAIN"
            );

            if (cartStatus) {
              cartStatus.textContent =
                error instanceof Error
                  ? error.message
                  : "Could not add the Flight Box subscription to cart.";
              cartStatus.hidden = false;
            }

          }

        }
      );

    }

    if (
      prelaunchForm &&
      isPrelaunch
    ) {

      prelaunchForm.addEventListener(
        "submit",
        (event) => {

          if (!profileIsComplete()) {
            event.preventDefault();

            if (cartStatus) {
              cartStatus.textContent =
                "Complete all six profile choices before joining the Flight List.";
              cartStatus.hidden =
                false;
            }

            return;
          }

          try {

            window.localStorage.setItem(
              prelaunchProfileStorageKey,
              JSON.stringify({
                flight:
                  answers.flight,
                skill:
                  answers.skill,
                weight:
                  answers.weight,
                color:
                  answers.color,
                brands:
                  answers.brands,
                distance:
                  answers.distance,
                savedAt:
                  new Date().toISOString()
              })
            );

            window.sessionStorage.setItem(
              prelaunchSubmitStorageKey,
              "true"
            );

          } catch (_) {

            return;

          }

        }
      );

    }


    /* ========================================
       INITIALIZE
    ======================================== */

    restorePrelaunchProfile();
    preselectAnswers();

    showStep(1);

    let returningFromPrelaunchSignup =
      false;

    try {

      returningFromPrelaunchSignup =
        window.sessionStorage.getItem(
          prelaunchSubmitStorageKey
        ) ===
        "true";

      if (returningFromPrelaunchSignup) {
        window.sessionStorage.removeItem(
          prelaunchSubmitStorageKey
        );
      }

    } catch (_) {

      returningFromPrelaunchSignup =
        false;

    }

    if (
      isPrelaunch &&
      (
        returningFromPrelaunchSignup ||
        prelaunchSuccess
      ) &&
      profileIsComplete()
    ) {

      builderStarted =
        true;

      showBuilder(
        false
      );

      showSummary();

      window.setTimeout(
        centerSummaryInViewport,
        100
      );

    }

    const initializeAccountProfile = () => {
      const pendingProfile =
        readPendingProfile();

      openBuilderFromLink();

      if (
        isPrelaunch &&
        prelaunchSuccess &&
        applyProfile(pendingProfile)
      ) {
        showBuilder(false);
        showSummary();

        if (prelaunchForm) {
          prelaunchForm.hidden = true;
        }

        window.setTimeout(
          () =>
            redirectToAccountProfile(),
          250
        );
      }
    };

    initializeAccountProfile();

    if (isEditMode) {
      showBuilder(false);
    }


    if (isEditMode) {

      setTimeout(
        () => {

          personalizer.scrollIntoView({
            behavior:
              "smooth",
            block:
              "start"
          });

        },
        2400
      );

    }

  }
  /* ========================================
     FLIGHT 001 SCROLL REVEAL
  ======================================== */

  const flight001 =
    document.querySelector(
      "[data-dd-flight-001]"
    );

  if (flight001) {

    const flight001Observer =
      new IntersectionObserver(
        (entries, observer) => {

          entries.forEach((entry) => {

            if (entry.isIntersecting) {

              flight001.classList.add(
                "dd-flight-001--visible"
              );

              observer.unobserve(
                entry.target
              );

            }

          });

        },
        {
          threshold: 0.15,
          rootMargin: "0px 0px -60px 0px"
        }
      );

    flight001Observer.observe(
      flight001
    );

  }
  
});
